import { render, staticRenderFns } from "./qyWechat.vue?vue&type=template&id=672b5a05&scoped=true"
import script from "./qyWechat.vue?vue&type=script&lang=js"
export * from "./qyWechat.vue?vue&type=script&lang=js"
import style0 from "./qyWechat.vue?vue&type=style&index=0&id=672b5a05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b5a05",
  null
  
)

export default component.exports